module.exports = "https://cdn.realtymogul.com/static/media/icon_cre.d1226fb6.svg";